if(typeof fancentro_promo === 'undefined') {var e = new Error("Cannot find module \"fancentro_promo\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = fancentro_promo;


//////////////////
// WEBPACK FOOTER
// external "fancentro_promo"
// module id = 84
// module chunks = 0